import { Chip, useTheme } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { resolveMobilityRunChip, resolveOrderStatusColor } from '@hopdrive/feature-order-index';

// TYPES ---------------------------------------------------------------------- //

interface RunStatusChipProps {
  /** A Mobile Service or Parts Delivery run's `mobility_runs.status`. */
  status: string;
  variant?: 'filled' | 'outlined';
  sx?: SxProps<Theme>;
}

// COMPONENT ------------------------------------------------------------------ //

/** A run's status in the label and colour its OrderIndex card wears, read from the package's run chip. */
const RunStatusChip = ({ status, variant = 'filled', sx }: RunStatusChipProps) => {
  const theme = useTheme();
  const chip = resolveMobilityRunChip(status);
  const color = resolveOrderStatusColor(theme, chip.token);
  const tone = variant === 'filled' ? { bgcolor: color, color: theme.palette.getContrastText(color) } : { color, borderColor: color };
  return <Chip label={chip.label} size='small' variant={variant} sx={[tone, ...(Array.isArray(sx) ? sx : [sx])]} />;
};

export default RunStatusChip;
